
import { API_URL } from '../config/api';

const API_BASE = API_URL;

const authHeaders = () => ({
  'Content-Type': 'application/json',
  'Accept': 'application/json',
  'Authorization': `Bearer ${localStorage.getItem('admin_token')}`,
});

const publicHeaders = () => ({
  'Content-Type': 'application/json',
  'Accept': 'application/json',
});

const handleResponse = async (res) => {
  if (!res.ok) {
    const err = await res.json().catch(() => ({}));
    throw { status: res.status, message: err.message || 'Erreur', errors: err.errors || {}, code: err.code };
  }
  return res.json();
};

//  SESSIONS (admin) 

export const getSessions = () =>
  fetch(`${API_BASE}/recueil-sessions`, { headers: authHeaders() }).then(handleResponse);

export const createSession = (data) =>
  fetch(`${API_BASE}/recueil-sessions`, {
    method: 'POST', headers: authHeaders(), body: JSON.stringify(data),
  }).then(handleResponse);

export const getSession = (id) =>
  fetch(`${API_BASE}/recueil-sessions/${id}`, { headers: authHeaders() }).then(handleResponse);

export const updateSession = (id, data) =>
  fetch(`${API_BASE}/recueil-sessions/${id}`, {
    method: 'PUT', headers: authHeaders(), body: JSON.stringify(data),
  }).then(handleResponse);

export const deleteSession = (id) =>
  fetch(`${API_BASE}/recueil-sessions/${id}`, {
    method: 'DELETE', headers: authHeaders(),
  }).then(handleResponse);

//  ENVOI LIENS (admin saisit des emails) 

export const envoyerLiens = (sessionId, emails, expireAt = null) =>
  fetch(`${API_BASE}/recueil-sessions/${sessionId}/envoyer`, {
    method: 'POST', headers: authHeaders(),
    body: JSON.stringify({ emails, expire_at: expireAt }),
  }).then(handleResponse);

export const relancerLien = (sessionId, lienId) =>
  fetch(`${API_BASE}/recueil-sessions/${sessionId}/liens/${lienId}/relancer`, {
    method: 'POST', headers: authHeaders(),
  }).then(handleResponse);

//  FICHES REÇUES (admin dashboard) ─

export const getAttentes = (sessionId) =>
  fetch(`${API_BASE}/recueil-sessions/${sessionId}/attentes`, {
    headers: authHeaders(),
  }).then(handleResponse);

//  FORMULAIRE PUBLIC (participant) ─

export const getRecueilInfo = async (token) => {
  const res = await fetch(`${API_BASE}/recueil/${token}/info`, { headers: publicHeaders() });
  if (res.status === 410) throw { code: 'EXPIRE' };
  if (res.status === 409) throw { code: 'DEJA_REMPLI' };
  if (res.status === 404) throw { code: 'INVALIDE' };
  if (!res.ok)            throw { code: 'INVALIDE' };
  return res.json();
};

export const submitRecueil = (token, formData) =>
  fetch(`${API_BASE}/recueil/${token}/submit`, {
    method: 'POST', headers: publicHeaders(), body: JSON.stringify(formData),
  }).then(handleResponse);